<template>
    <canvas ref="chart" width="100" height="100" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { Chart, type TooltipItem } from "./chart";

const chart = ref<HTMLCanvasElement | null>(null);
const parameters: any = {
    type: "bar",
    data: {
        labels: ["Asleep in 30 Minutes", "Better Sleep in 30 Days"],
        datasets: [
            {
                label: "% of Participants",
                data: [78, 96],
                backgroundColor: [
                    "rgba(0, 192, 0, 0.3)",
                    "rgba(24, 140, 251, 0.3)",
                ],
                borderColor: ["rgba(0, 192, 0, 1)", "rgba(24, 140, 251, 1)"],
                borderWidth: 1,
            },
        ],
    },
    options: {
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: function (value: number | string) {
                        return `${value}%`;
                    },
                },
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: function (context: TooltipItem<"bar">) {
                        return `${context.formattedValue}%`;
                    },
                },
            },
        },
    },
};

onMounted(() => {
    if (chart.value) {
        new Chart(chart.value, parameters);
    }
});
</script>
